<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="box">
      <Title title="套餐订单-筛选"/>
      <div class="order_screening_box" style="height: 90px">
        <div class="mediaPackageTitle">
          媒介套餐
        </div>
        <div class="search_status_box flex" style="margin-top: 25px;justify-content: center">
          <div class="search_box flex">
            <order_time @get_time="get_time"/>
            <div class="order_search flex">
              <img src="@/assets/user/setMenu/search.png" alt="" class="search_icon"/>
              <el-input class="order_search_inp" v-model="orderId" placeholder="输入标题/订单号"></el-input>
              <button class="search_but" @click="get_list">搜索</button>
            </div>
          </div>
        </div>
      </div>
      <div class="mediaOrdersLists">
        <Title title="套餐订单-列表"/>
        <orderStatus ref="orderstatus_tab" :category_id="0" :status_list="status_list"
                     type="package_status_num" @status_tab="status_tab" :order_status="packOrder.order_status"/>
      </div>
      <div class="ct_box">
        <table class="package_table">
          <thead>
          <tr>
            <td>套餐名称</td>
            <td>订单号</td>
            <td>标题</td>
            <td>稿件详情</td>
            <td>金额</td>
            <td>状态</td>
            <td>创建时间</td>
            <!--            <td>撤稿原因</td>-->
            <td style="width: 190px">操作</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in tableData" :key="item.id">
            <td>{{ item.medium_title }}</td>
            <td>
              {{ item.sn }}
            </td>
            <td>
              <td_remark :text="item.title"/>

            </td>
            <td><span class="look" @click="lookShow(item.id)">[查看]</span></td>
            <td>￥{{ item.medium_price }}</td>
            <td style="font-weight: 700">
              <div style="display: flex;flex-direction: column">
                <div>
                  <span v-if="item.order_status === 0">未处理</span>
                  <span v-if="item.order_status === 1" style="color: rgba(23, 194, 4, 1)">发布中</span>
                  <span v-if="item.order_status === 2" style="color: rgba(255, 106, 0, 1)">已出稿</span>
                  <span v-if="item.order_status === 3" style="color: rgba(255, 162, 0, 1)">申请退款</span>
                  <span v-if="item.order_status === 4" style="color: rgba(224, 2, 32, 1)">拒绝退款</span>
                  <span v-if="item.order_status === 5" style="color: rgba(16, 140, 221, 1)">撤稿</span>
                  <span v-show="item.order_status === 0 || item.order_status === 1"
                        style="color: #FF0000;">{{
                      item.is_limit == 1 ? '[已超时]' : ''
                    }}</span>
                </div>

                <!--                媒介主退稿的原因显示-->
                <el-tooltip class="item" style="margin-top: 10px" effect="dark"
                            v-if="item.reason!=='' && item.order_status ===5"
                            :content='`${item.reason.id==="请选择"?"":`${item.reason.id}，`}${item.reason.reason}`'
                            placement="top">
                  <el-button plain class="seeWhy_1">查看原因</el-button>
                </el-tooltip>

                <!--                拒绝退款的原因显示-->
                <el-tooltip class="item" style="margin-top: 10px" effect="dark"
                            v-if="item.reason4.reason!=='' && item.order_status ===4"
                            :content="item.reason4.reason"
                            placement="top">
                  <el-button plain class="seeWhy_1">查看原因</el-button>
                </el-tooltip>
              </div>
            </td>
            <td>{{ item.ctime }}</td>
            <!--            <td>-->
            <!--              <td_remark :text="item.reason.id"/>-->
            <!--              <td_remark :text="item.reason.season"/>-->
            <!--            </td>-->
            <td class="operation3">
              <!-- ' -->
              <span v-if="item.order_status == 2" @click="LinkShow(item)">查看链接</span>
              <span
                  v-if="(item.order_status == 0 && item.is_limit) || (item.order_status == 1 && item.is_limit) || item.order_status == 0"
                  @click="withdraw(item)">撤稿</span>
              <!-- <span v-if="item.order_status == 0" @click="orderStatus(item, 5)">撤稿</span> -->

              <span
                  v-if="(item.order_status == 1 && !item.is_limit) || (item.order_status == 2 && !item.is_limit)"
                  @click="orderStatus(item, 3)">申请退款</span>

              <!-- <span @click="redispatchFn(item)" v-if="item.order_status == 2">再发布</span> -->
              <span @click="orderShow(item)" v-if="item.order_status == 2">提交工单</span>
              <span v-if="item.order_status == 4 || item.order_status == 9 || item.order_status == 7"
                    @click="serviceShow = true">联系客服</span>
              <span @click="Over(item)"
                    v-if="item.order_status == 3 || item.order_status == 4">取消退款</span>
              <span v-if="item.order_status == 0 || item.order_status == 5"
                    @click="goEdit(item)">修改稿件</span>
              <span @click="issue(item)"
                    v-if="item.order_status == 2 || item.order_status == 5 || item.order_status == 8">重新发布</span>

            </td>
          </tr>
          </tbody>
        </table>
        <!-- 分页器 -->
        <pagination :page="page" @pageChange="pageChange" :total_order_price="total_order_price" :count="count"
                    :total_page="total_page"/>
      </div>
    </div>
    <!-- 查看链接 -->
    <el-dialog title="查看链接" :append-to-body="true" :visible.sync="Link" :show-close="true">
      <table class="table2" style="border-radius: 20px 20px 0 0">
        <thead class="thead_2">
        <tr>
          <td>标题</td>
          <td>媒介</td>
          <td>链接</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ linkList.title }}</td>
          <td>{{ linkList.medium_title }}</td>
          <td style="width: 25rem;">https://www.qixuantong.com{{ linkList.order_url }}</td>
        </tr>
        </tbody>
      </table>
      <div class="flex" style="margin-top: 2rem; justify-content: flex-end">
        <button class="copy_but" @click="copy">复制链接</button>
      </div>
    </el-dialog>
    <el-dialog title="提交工单" :append-to-body="true" :visible.sync="order" :show-close="true">
      <p class="workOrder_title">请描述您的问题</p>
      <el-input type="textarea" :rows="6" resize="none" v-model="work">
      </el-input>
      <div class="flex" style="margin-top: 2rem; justify-content: flex-end">
        <button class="copy_but" @click="orderUp">确认提交</button>
      </div>
    </el-dialog>
    <el-dialog title="联系客服" :append-to-body="true" :visible.sync="serviceShow" :show-close="false">
      <p class="workOrder_title">客服电话：83730126/82821214</p>

    </el-dialog>
    <media_rejection_poup :himt="popupObj.himt" :order_status="order_status" :placeholder="popupObj.placeholder"
                          :reason_title="popupObj.title" :title="popupObj.title" :rejectShow="rejectShow"
                          :rejectItem="rejectItem"
                          @rejectComfirm="rejectComfirm" @rejectClose="rejectShow = false"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Title from '@/components/UserInfoTitle'
import media_rejection_poup from '@/components/media_rejection_poup'
import orderStatus from '@/components/orderStatus'
import order_time from '@/components/order_time'
import order_link_poup from "@/components/order_link_poup.vue";

export default {
  components: {
    order_link_poup,
    Title,
    media_rejection_poup,
    orderStatus,
    order_time,
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.$refs.orderstatus_tab.getNum(0)
      }
    }
  },
  created() {
    if (this.$route.query.time) {
      this.packOrder.order_status = 6
    }
    this.get_list()
  },
  computed: {
    ...mapState(['packOrder'])
  },

  data() {
    return {
      time: '',
      orderId: '',
      tableData: [],
      Link: false, //查看链接弹窗
      order: false, //提交工单弹窗
      orderItem: {}, //工单信息
      serviceShow: false, //客服
      work: '',
      total_page: 0, //分页总页数
      total_order_price: 0, //条数总和
      count: 0, //总条数
      page: 1,
      linkList: {},
      fullscreenLoading: false, //loding
      rejectShow: false,
      order_status: 0,
      rejectItem: {},
      popupObj: {
        himt: '',
        title: '',
        reason_title: '',
        placeholder: '',

      },
      status_list: [
        {
          id: '',
          title: '全部',
        },
        {
          id: 0,
          title: '未处理',
        },
        {
          id: 1,
          title: '发布中',
        },
        {
          id: 2,
          title: '已出稿',
        },
        {
          id: 3,
          title: '申请退款',
        },
        {
          id: 4,
          title: '拒绝退款',
        },
        {
          id: 5,
          title: '撤稿',
        },
        {
          id: 6,
          title: '限时订单',
        },
      ],
    }
  },
  methods: {
    status_tab(id) {
      // console.log(id)
      this.packOrder.order_status = id
      this.pageChange(1)

    },
    get_time(time) {
      this.time = time || []
      this.pageChange(1)
    },
    pageChange(pageVal) {
      this.page = pageVal
      this.get_list()
    },

    LinkShow(item) {
      this.linkList = {
        title: item.title,
        order_url: item.order_url,
        medium_title: item.medium_title,
      }
      this.Link = true
    },
    rejectComfirm() {
      this.rejectShow = false
      this.get_list()
    },
    orderShow(item) {
      this.order = true
      this.orderItem = item
      console.log(item);
    },
    copy() {
      //参数是复制的内容
      //.then()中的函数是复制成功和复制失败的两个回调函数
      this.$copyText(`${this.linkList.title} | ${this.linkList.medium_title} | https://www.qixuantong.com/${this.linkList.order_url}`).then(
          (e) => {
            return this.$message({
              message: '复制成功',
              type: 'success',
            })
          },
          (err) => {
            return this.$message({
              message: '复制失败',
              type: 'warning',
            })
          }
      )
    },
    // 下载链接
    download(item) {
      window.open(`${item.order_url}`, '_blank')
    },
    // 提交
    orderUp() {
      if (this.work != '') {
        this.curlPost('/api/users/work/add', {
          order_id: this.orderItem.id,
          desc: this.work,
        }).then((res) => {
          console.log(res)
          if (res.data.code) {
            this.get_list()
            this.work = ''
            this.order = false
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            return this.$router.push('/user/MyOrder')
          } else {
            return this.$message({
              message: '提交失败',
              type: 'warning',
            })
          }
        })
      }
    },
    lookShow(item) {
      const {href} = this.$router.resolve({
        name: 'lookdetails',
        query: {
          id: item
        }
      })
      window.open(href, '_blank',)
    },
    // 申请退款
    orderStatus(item, status) {
      this.rejectItem = JSON.parse(JSON.stringify(item))
      this.order_status = status
      this.rejectShow = true
      if (status == 3) {
        this.popupObj.himt = '提示：此稿件确定要申请退款吗?'
        this.popupObj.title = '申请退款'
        this.popupObj.placeholder = '请输入退款原因'
        this.reason_title = '退款原因'
      } else {
        this.popupObj.himt = '提示：此稿件确定要撤稿吗?'
        this.popupObj.title = '撤稿'
        this.popupObj.placeholder = '请输入撤稿原因'
        this.reason_title = '撤稿原因'
      }
    },
    // 撤稿
    withdraw(item) {
      this.$confirm('是否申请撤稿?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            this.curlPost('/api/users/order/edit', {
              id: item.id,
              status: 5,
              url: item.order_url,
            }).then((res) => {
              console.log(res)
              if (res.data.code) {
                this.get_list()
              }
            })
            this.$message({
              type: 'success',
              message: '申请撤稿成功',
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
    },
    // 继续发布
    issue(item) {
      this.$confirm('是否重新发布?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            this.curlPost('/api/users/order/edit', {
              id: item.id,
              status: 0,
              url: item.order_url,
            }).then((res) => {
              console.log(res)
              if (res.data.code) {
                this.get_list()
              }
            })
            this.$message({
              type: 'success',
              message: '待发布 ',
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
    },
    // 编辑稿件
    goEdit(item) {
      this.$store.commit('childTab', '套餐发布')
      this.$router.push({
        path: '/user/edit_fill?id=' + item.id,
      })
      // this.$router.push({
      // 	path: '/user/edit_fill',
      // 	query: {
      // 		id: item.id,
      // 	},
      // })
    },
    // 取消退款
    Over(item) {
      console.log(item)
      this.$confirm('是否取消退款?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(() => {
            this.curlPost('/api/users/order/edit', {
              id: item.id,
              status: 1,
              url: item.order_url,
            }).then((res) => {
              console.log(res)
              if (res.data.code) {
                this.$message({
                  type: 'success',
                  message: '待发布 ',
                })
                this.get_list()
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
    },
    // 再发布
    redispatchFn(item) {
      console.log(item)
      this.$store.commit('childTab', '套餐发布')
      this.$router.push({
        path: '/user/SetMenu/fill?id=8',

      })
    },
    get_list() {
      this.fullscreenLoading = true
      let data = {}
      data.page = this.page
      data.limit = 20
      if (this.packOrder.order_status !== '') {
        data.order_status = this.packOrder.order_status
      }
      if (this.orderId !== '') {
        data.title = this.orderId
      }
      if (this.time.length) {
        data.start_time = this.time[0] / 1000;
        data.end_time = this.time[1] / 1000;
      }
      data.type = 'package'
      this.curlGet('/api/users/order/list', data).then((res) => {
        if (res.data.code) {
          this.total_page = res.data.data.total_page
          this.tableData = res.data.data.list
          console.log(res.data, 'data');
          if (data.order_status == 2) {
            this.total_order_price = res.data.data.total_order_price
            this.count = 0
          } else {
            this.count = res.data.data.count
            this.total_order_price = 0
          }
          this.fullscreenLoading = false
        }
      })

    },
    // 切换页
    currentTab(val) {
      console.log('切换')
      this.page = val
      this.ListFn()
    },
    // 上一页
    prevClick() {
      console.log('up')
      this.page -= 1
      this.ListFn()
    },
    // 下一页
    // next-click
    nextClick() {
      console.log('down')
      this.page += 1
      this.ListFn()
    },
    // 选中日期后的回调
    timerFn() {
      console.log(this.time)
      this.get_list()
    },
    // 切换页
    currentTab(val) {
      console.log('切换')
      this.page = val
      this.ListFn()
    },
    // 上一页
    prevClick() {
      console.log('up')
      this.page -= 1
      this.ListFn()
    },
    // 下一页
    // next-click
    nextClick() {
      console.log('down')
      this.page += 1
      this.ListFn()
    },

  },
}
</script>

<style lang="scss" scoped>
@use '@/scss/MediaOrder';

.seeWhy_1 {
  background: rgba(255, 255, 255, 1);
  color: rgba(16, 140, 221, 1);
  border: 1px solid rgba(16, 140, 221, 1);
  padding: 2px;
}
</style>